<template>
  <div class="detected" v-if="detected">
    <div
      class="no-rule"
      :class="{ 'no-rule-show': !detectedNew }"
      @click="detectedShowList"
    >
      <span class="rule-icon" v-if="detectedNew">
        <img src="../../svg/violation.svg" />
      </span>
      <span v-else>
        <img src="../../svg/violation-show.svg" />
      </span>
      <span v-if="detectedNew">{{ $t('aheader.检测到页面违规') }}</span>
    </div>
    <ruleList v-if="ruleListShow" :ruleListShow.sync="ruleListShow" />
  </div>
</template>
<script>
import alteringIcon from '@/svg/altering.svg';
import { pushRoomMessageFunc } from '@/utils/socketMessageDispose';
import ruleList from '@/components/include/ruleList.vue';
import { mapGetters } from 'vuex';
import Bus from '@/components/doc/bus';
export default {
  name: 'detected',
  data() {
    return {
      detected: false,
      detectedNew: false,
      ruleListShow: false, //显示违规列表
      detectedMessage: false, //是否提示有新的违规画面
      alteringUrl: alteringIcon,
      hasTips: false //是否显示违规提示
    };
  },
  components: {
    ruleList
  },
  computed: {
    ...mapGetters(['audioAudit', 'userInfo']),
    role() {
      //3:主播 2：助手 1：嘉宾
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type;
    }
  },
  watch: {
    audioAudit: {
      handler(newValue, oldValue) {
        console.log(oldValue, 'audioAudit');
        //如果是主播才显示
        if (newValue && this.role == 3) {
          this.detected = true;
        } else {
          this.detected = false;
        }
      },
      immediate: true
    }
  },
  created() {
    pushRoomMessageFunc(({ cmd, requestData }) => {
      const fn = this[`message_${cmd}`];
      typeof fn === 'function' && fn(requestData);
    });
  },
  methods: {
    /**
     * 点击打开违规列表
     */
    detectedShowList() {
      this.detectedNew = false;
      this.ruleListShow = true;
    },
    message_7127(body) {
      switch (body.event) {
        case 'cloud_webcast_video_picture_data': {
          if (this.role == 3) {
            this.detected = true;
            this.detectedNew = true;
            if (!this.detectedMessage && !this.hasTips) {
              this.detectedPicture();
            }
          }
          break;
        }
        case 'TO_BE_MAIN_CONTROL': {
          if (body.role === 'host') {
            console.log(this.audioAudit, 'audioAudit....');
            if (this.audioAudit) {
              if (body.uid !== this.userInfo?.uid) {
                this.detected = false;
              } else {
                this.detected = true;
              }
            }
          }
          break;
        }
      }
    },
    detectedPicture() {
      this.hasTips = true;
      this.$confirm(
        `<div style="display:flex;justify-content: center;align-items: center;"><img src="${
          this.alteringUrl
        }" style="margin-right:10px;"/>${this.$t('aheader.系统检测到当前直播存在违规画面')}</div>`,
        `${this.$t('aheader.提示')}`,
        {
          confirmButtonText: this.$t('aheader.查看'),
          cancelButtonText: this.$t('aheader.不再提示'),
          dangerouslyUseHTMLString: true,
          distinguishCancelAndClose: true
        }
      )
        .then(() => {
          this.ruleListShow = true;
          this.detectedNew = false;
          this.hasTips = false;
          Bus.$emit('lists');
        })
        .catch((e) => {
          if (e === 'cancel') {
            this.detectedMessage = true;
          }
          this.hasTips = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.detected {
  position: absolute;
  top: -25px;
  left: 12px;
  z-index: 99999;
}
.no-rule {
  color: #fff;
  width: 110px;
  height: 24px;
  background: #ea494b;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 16px;
  font-size: 10px;
}
.no-rule-show {
  width: 24px;
  background: none;
}
.rule-icon {
  display: flex;
  margin-right: 2px;
}
</style>
